module.exports = __webpack_public_path__ + "assets/img/67_313.017b9fcd.jpg";